import Marquee from "react-fast-marquee";
import { SYMBOL_URL } from "../data/content";

const words = [
  "It didn't start with clothing",
  "It started here",
  "Chapter I — 26.11.2026",
  "The black dog has a name",
  "We draw what we can't say",
  "Drawn on the hardest nights",
  "Paper first — fabric later",
  "Three works · three hundred pieces",
  "A society, not a store",
  "Wear the weight",
];

export const Ticker = () => (
  <div data-testid="marquee" className="py-14 md:py-20 border-y border-bds-border overflow-x-hidden overflow-y-visible">
    <Marquee speed={75} gradient={false} autoFill>
      {words.map((w, i) => (
        <span key={i} className="mx-10 md:mx-16 inline-flex items-center gap-10 md:gap-16">
          <span className="font-serif-display italic font-light text-5xl md:text-7xl lg:text-8xl leading-[1.35] py-[0.12em] text-bds-fg/90 whitespace-nowrap">
            {w}
          </span>
          <img src={SYMBOL_URL} alt="" aria-hidden className="h-10 md:h-14 w-auto object-contain mix-blend-screen opacity-90" />
        </span>
      ))}
    </Marquee>
  </div>
);
